document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-videos]').forEach(function (section) {
    var track = section.querySelector('[data-videos-track]');
    var prevBtn = section.querySelector('[data-videos-prev]');
    var nextBtn = section.querySelector('[data-videos-next]');
    var cards = section.querySelectorAll('[data-video-card]');

    if (!track || !cards.length) return;

    /* ---------- Play / pause ---------- */

    function pauseAllExcept(keepCard) {
      cards.forEach(function (card) {
        if (card === keepCard) return;
        var v = card.querySelector('[data-video-el]');
        if (v && !v.paused) v.pause();
      });
    }

    cards.forEach(function (card) {
      var video = card.querySelector('[data-video-el]');
      if (!video) return;

      function toggle() {
        if (video.paused) {
          pauseAllExcept(card);
          // When a frame is shown as the thumbnail, the src carries a #t=
          // fragment that parks the video partway in. Start the first
          // play from the beginning instead.
          if (!video.dataset.started) {
            video.dataset.started = 'true';
            video.currentTime = 0;
          }
          var attempt = video.play();
          // play() returns a promise in modern browsers; swallow a
          // rejected one (e.g. the file failed to load) rather than
          // leaving an unhandled error in the console.
          if (attempt && typeof attempt.catch === 'function') {
            attempt.catch(function () {});
          }
        } else {
          video.pause();
        }
      }

      card.addEventListener('click', toggle);

      video.addEventListener('play', function () {
        card.classList.add('is-playing');
      });
      video.addEventListener('pause', function () {
        card.classList.remove('is-playing');
      });
      video.addEventListener('ended', function () {
        card.classList.remove('is-playing');
      });
    });

    // Stop anything still playing once the section scrolls out of view.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) pauseAllExcept(null);
          });
        },
        { threshold: 0 }
      ).observe(section);
    }

    /* ---------- Arrows ---------- */

    function updateArrows() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var hasOverflow = maxScroll > 4;
      if (prevBtn) prevBtn.hidden = !hasOverflow || track.scrollLeft <= 4;
      if (nextBtn) nextBtn.hidden = !hasOverflow || track.scrollLeft >= maxScroll - 4;
    }

    function scrollByCard(direction) {
      var card = cards[0];
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = card.offsetWidth + gap;
      track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        scrollByCard(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        scrollByCard(1);
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  });
});